import { svgSprite } from '../../../../../../hybrid/wrappers';
import uikit from '../../../../../../project/uikit/uikit.module.scss';
import FormInput from '../../../form-input/FormInput/FormInput';
import css from './EditTitlteOfCheckbox.module.scss';
import classnames from 'classnames';

const EditTitlteOfCheckbox = ({ setShowInput, setNewTitle, title, saveEditTitle, attribute, newTitle, number }) => {
    return (
        <div className={uikit.flexRow}>
            <FormInput
                attribute='title'
                type='input'
                compStyle={{ wrapper: { marginBottom: '0' } }}
                handlers={{}}
                setFormData={(key, value) => {
                    setNewTitle(value);
                }}
                value={title}
            />
            <div style={{ marginLeft: '8px' }} className={classnames(uikit.flexRow, uikit.alignItemsCenter)}>
                <div
                    className={css.formCheckboxSwitcherEditIconHover}
                    style={{ padding: '8px 11px' }}
                    onClick={() => {
                        saveEditTitle(attribute, newTitle || title, number);
                        setShowInput(false);
                    }}
                >
                    {svgSprite('check', {
                        className: css.formCheckboxSwitcherEditIconCheck
                    })}
                </div>
                <div
                    className={css.formCheckboxSwitcherEditIconHover}
                    style={{ padding: '8px 11px' }}
                    onClick={() => {
                        setShowInput(false);
                        setNewTitle(title);
                    }}
                >
                    {svgSprite('cross', {
                        className: css.formCheckboxSwitcherEditIconClose
                    })}
                </div>
            </div>
        </div>
    );
};
export default EditTitlteOfCheckbox;
